import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  button: {
    height: 50,
    marginBottom: '1rem',
  },
  headerText: {
    fontSize: 32,
    color: theme.palette.gray.efesDarkGray,
    fontWeight: 'bold',
    marginBottom: '1rem',
    textTransform: 'uppercase',
    [theme.breakpoints.down('lg')]: {
      fontWeight: 'normal',
      fontSize: 24,
    },
  },
}));

export default useStyles;
